/* Model */
class OrderModel extends App.Models.BaseModel {
    modelUrl = 'Order';

    fetchWithCriteria = (obj) => {
        return Monet.Model.fetchWithCriteria({
            options: obj,
            model: this
        });
    }

    lineItems = (obj) => {
        return Monet.Model.hasMany({
            options: obj,
            parent: this,
            collection: App.Collections.LineItems,
            model: App.Models.LineItem
        });
    }
}

App.Models.Order = OrderModel;